/**
 * Scheduler Theme Configuration
 * Centralized color definitions for the scheduler component
 */

export const schedulerTheme = {
  // Lane and cell states
  laneStates: {
    normal: {
      background: '#ffffff',
      hover: '#fafafa',
      header: '#fafafa',
    },
    default: {
      background: '#e6f4ff',
      hover: '#bae7ff',
      header: '#e6f4ff',
    },
    conflict: {
      background: '#fbf3f2',
      hover: '#ffccc7',
      header: '#ffccc7',
      border: '#820014',
    },
    conflictDefault: {
      background: '#fffbe6',
      hover: '#ffe58f',
      header: '#fffbe6',
      border: '#ad6800',
    },
    outsideHours: {
      background: '#f5f5f5',
      hover: '#eeeeee',
    },
  },

  // Appointment status colors
  appointmentStatus: {
    toDo: {
      background: '#faad14',
      hover: '#f7b500',
      border: '#faad14',
    },
    inProgress: {
      background: '#1890ff',
      hover: '#0050b3',
      border: '#1890ff',
    },
    completed: {
      background: '#52c41a',
      hover: '#389e0d',
      border: '#52c41a',
    },
    cancelled: {
      background: '#d9d9d9',
      hover: '#bfbfbf',
      border: '#d9d9d9',
      text: '#666666',
    },
    authorized: {
      background: '#52c41a',
      hover: '#389e0d',
      border: '#52c41a',
    },
    unauthorized: {
      background: '#ff7a45',
      hover: '#ff6b35',
      border: '#ff7a45',
    },
  },

  // UI elements
  ui: {
    currentTimeIndicator: '#52c41a',
    tradingTimeOpen: '#52c41a',
    tradingTimeClose: '#ff4d4f',
    border: 'rgba(0, 0, 0, 0.06)',
    text: '#333333',
    textSecondary: '#666666',
    textDisabled: '#bfbfbf',
  },
} as const;

export type LaneState = 'normal' | 'default' | 'conflict' | 'conflictDefault';

/**
 * Determines the lane state based on conflict and default lane flags
 */
export function getLaneState(
  hasConflict: boolean,
  isDefaultLane: boolean
): LaneState {
  if (hasConflict && isDefaultLane) {
    return 'conflictDefault';
  }
  if (hasConflict) {
    return 'conflict';
  }
  if (isDefaultLane) {
    return 'default';
  }
  return 'normal';
}
